module.exports = __webpack_public_path__ + "img/user-circle.d23cf213.svg";